/**
 * @module use-cases/cart/actions
 * @desc Cart Action Creators
 *
 */

import { createAction, createAsyncAction } from 'core/use-cases/utilities';

import type {
  Cart,
  CartItemBase,
  Combo,
  User,
  ShippingModelBusiness,
  ShippingModelStep,
} from 'core/domains';

export const checkoutRedirectFlow =
  createAction<'@@checkoutRedirectFlow'>('@@checkoutRedirectFlow');

export const giftsFlowCheck = createAction<'@@giftsFlowCheck'>('@@giftsFlowCheck');

export const discountProcess = createAction<'discountProcess'>('discountProcess');

export const viewCart = createAction<'viewCart'>('viewCart');

export const setCouponFetch = createAsyncAction<
  'setCouponFetch',
  { couponNumber: string },
  Cart['data']
>('setCouponFetch');

export const setIsValidCoupon = createAction<
  'setIsValidCoupon',
  Cart['data']['coupon']['isValidCoupon']
>('setIsValidCoupon');

export const clearCouponFetch = createAsyncAction<
  'clearCouponFetch',
  { couponNumber: null },
  Cart['data']
>('clearCouponFetch');

export const cartCleanUp = createAction('cartCleanUp');

export const toggleDeleteConfirmation = createAction<
  'toggleDeleteConfirmation',
  Cart['deleteConfirmation']['data']['productCode']
>('toggleDeleteConfirmation');

export const toggleMinOrderConfirmation = createAction<'toggleMinOrderConfirmation'>(
  'toggleMinOrderConfirmation',
);

export const cartFetch = createAsyncAction<'cartFetch', undefined, Cart['data']>('cartFetch');
export const lastCartFetch = createAsyncAction<'lastCartFetch', undefined, Cart['data']>(
  'lastCartFetch',
);

export const cartCurrentDeliveryFetch = createAsyncAction<
  'cartCurrentDeliveryFetch',
  undefined,
  Cart['data']
>('cartCurrentDeliveryFetch');

export const cartFetchForGiftsCheck = createAsyncAction<
  'cartFetchForGiftsCheck',
  undefined,
  Cart['data']
>('cartFetchForGiftsCheck');

export const cartSetShippingModelFetch = createAsyncAction<
  'cartSetShippingModelFetch',
  Cart['current']['shippingModel'],
  Cart['data']
>('cartSetShippingModelFetch');

export const setDefaultShippingModel = createAction<
  'setDefaultShippingModel',
  User['data']['shippingModel']['default']
>('setDefaultShippingModel');

export const setBusinessModel = createAction<'setBusinessModel', ShippingModelBusiness>(
  'setBusinessModel',
);

export const setShippingModelStep = createAction<'setShippingModelStep', ShippingModelStep>(
  'setShippingModelStep',
);

export const setDistributionCenter = createAction<
  'setDistributionCenter',
  {
    address: Cart['current']['distributionCenterAddress'];
    code: Cart['current']['shippingModel']['distributionCenterCode'];
  }
>('setDistributionCenter');

export const itemAddFetch = createAsyncAction<'itemAddFetch', CartItemBase, Cart['data']>(
  'itemAddFetch',
);

export const itemDeleteFetch = createAsyncAction<'itemDeleteFetch', CartItemBase, Cart['data']>(
  'itemDeleteFetch',
);

export const itemUpdateFetch = createAsyncAction<'itemUpdateFetch', CartItemBase, Cart['data']>(
  'itemUpdateFetch',
);

export const toggleComboEditConfirmation = createAction<
  'toggleComboEditConfirmation',
  Combo['data']['comboCode']
>('toggleComboEditConfirmation');

export const cartResetState = createAction('cartResetState');
